import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoModal from '@/components/common/InfoModal/InfoModal';
import { IAssetError, IImageAsset } from '@/data/models/album';
import './ImageInfoModal.scss';

interface Props {
  asset: IImageAsset | null | undefined;
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
}

interface TransArgs {
  [key: string]: string;
}

export default function ImageInfoModal({
  asset,
  showModal,
  setShowModal,
}: Props) {
  const { t } = useTranslation();

  const handleClose = () => {
    setShowModal(false);
  };

  const renderError = (error: IAssetError) => {
    if (!error.key) return;

    const errorTranslationKey = `validationAlert.${error.key}.ErrorMessage`;
    const transArgs: TransArgs = {};
    error.args?.forEach((arg, i) => {
      transArgs[i] = arg ? arg : t('common.generic.unknown');
    });

    return <li>{`${t(errorTranslationKey, transArgs)}`}</li>;
  };

  return (
    <InfoModal
      titleText={t('upload.image_info_modal_header')}
      show={showModal}
      onClose={handleClose}
    >
      <div>
        <h4>{t('upload.validation_specifications')}</h4>
        <ul className="validation-modal-error-list">
          <li>{`${t('upload.image_validation_width')}: ${asset?.imageMetadata?.width ?? t('common.generic.unknown')} `}</li>
          <li>{`${t('upload.image_validation_height')}: ${asset?.imageMetadata?.height ?? t('common.generic.unknown')} `}</li>
          <li>{`${t('upload.image_validation_dpi')}: ${asset?.imageMetadata?.dpi ?? t('common.generic.unknown')} `}</li>
          <li>{`${t('upload.image_validation_color_model')}: ${asset?.imageMetadata?.colorModel ?? t('common.generic.unknown')} `}</li>
          <li>{`${t('upload.image_validation_image_format')}: ${asset?.imageMetadata?.imageFormat ?? t('common.generic.unknown')} `}</li>
          <li>{`${t('upload.image_validation_embedded_color_profile')}: ${asset?.imageMetadata?.embeddedColorProfile ?? t('common.generic.unknown')} `}</li>
        </ul>
        <h4>{t('upload.reasons_invalid')}</h4>
        <ul className="validation-modal-error-list">
          {asset?.errors?.map((err) => renderError(err))}
        </ul>
      </div>
    </InfoModal>
  );
}
